export const ROLE = '/role/' as const
export const ROLE_ALL = `${ROLE}all` as const
export const ROLE_UPDATE_USER = `${ROLE}update-user` as const
export const ROLE_WITH_USERS = `${ROLE}with-users` as const
